export function parseDungeonFloorFromPath(pathname: string): number | null {
  const path = pathname.replace(/\/+$/, "") || "/";
  const match = /^\/dungeon\/floor\/(\d+)$/.exec(path);
  if (!match) return null;
  const floor = Math.floor(Number(match[1]));
  if (!Number.isFinite(floor) || floor < 1 || floor > 50) return null;
  return floor;
}

export function parseDungeonFloorFromQuery(search: string): number | null {
  const params = new URLSearchParams(search);
  const raw = params.get("floor");
  if (!raw) return null;
  const floor = Math.floor(Number(raw));
  if (!Number.isFinite(floor) || floor < 1 || floor > 50) return null;
  return floor;
}

export function homeDungeonFloorHref(floor: number): string {
  const f = Math.max(1, Math.floor(floor));
  return `/home?floor=${f}`;
}

/** Deep link for floor editor on home (not `/dungeon/floor/*`). */
export function dungeonFloorPath(floor: number): string {
  return homeDungeonFloorHref(floor);
}
